module.exports = __webpack_public_path__ + "media/application/images/trunk-logo-f43c1311a9b54a1ede40c197338681ad.svg";